import { t as e } from "./article-list.selector-DuAMaM-L.js";
import { defineAsyncComponent as t } from "vue";
//#endregion
//#region src/lang/index.ts
var n = {
	en: { backgroundArticle: {
		contentBlockLabel: "Highlighted link",
		titleInputLabel: "Highlighted link headline",
		buttonLabel: "Select an article",
		selectorLabel: "Select article",
		teaser: "Additional headline",
		switchLabel: "Replace article"
	} },
	de: { backgroundArticle: {
		contentBlockLabel: "Hervorgehobener Link",
		titleInputLabel: "Hervorgehobener-Link-Überschrift",
		buttonLabel: "Artikel auswählen",
		selectorLabel: "Artikel auswählen",
		teaser: "Zusätzliche Überschrift",
		switchLabel: "Artikel austauschen"
	} }
}, r = t(() => import("./background-article-block-Cy9Ro-3J.js")), i = {
	messages: n,
	routes: [],
	contentBlocks: [{
		type: "BACKGROUND_ARTICLE",
		label: "backgroundArticle.contentBlockLabel",
		icon: "file-text",
		component: r,
		defaultValue: {
			type: "BACKGROUND_ARTICLE",
			contentUuid: "",
			teaser: "",
			imageUuid: "",
			mediaType: ""
		}
	}]
};
//#endregion
export { e as ArticleListSelector, r as BackgroundArticleBlock, i as backgroundArticleModule };

//# sourceMappingURL=index.es.js.map